// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import purchaseDeliveryEntity from './entities/purchase-delivery.json';
import purchaseDeliveryMenu from '../pages/purchase-delivery/menu.json';
import purchaseDeliveryFullForm from '../pages/purchase-delivery/forms/full.json';
import purchaseDeliveryContextForm from '../pages/purchase-delivery/forms/context.json';
import purchaseDeliveryMiniForm from '../pages/purchase-delivery/forms/mini.json';
import purchaseDeliveryLookupForm from '../pages/purchase-delivery/forms/lookup.json';
import purchaseDeliveryTableView from '../pages/purchase-delivery/views/table.json';
import purchaseDeliveryCardsView from '../pages/purchase-delivery/views/cards.json';
import purchaseDeliveryCalendarView from '../pages/purchase-delivery/views/calendar.json';
import purchaseDeliveryDashboardView from '../pages/purchase-delivery/views/dashboard.json';

/** Тип запису «Поставка» зі сторінками пакета: меню, форми та подання з pages/purchase-delivery/. */
export const purchaseDeliveryDefinition: IRecordTypeDefinition = {
  ...purchaseDeliveryEntity,
  views: assembleViewSet({
      table: purchaseDeliveryTableView,
      cards: purchaseDeliveryCardsView,
      calendar: purchaseDeliveryCalendarView,
      dashboard: purchaseDeliveryDashboardView,
  }),
  form: purchaseDeliveryFullForm,
  forms: { full: purchaseDeliveryFullForm, context: purchaseDeliveryContextForm, mini: purchaseDeliveryMiniForm, lookup: purchaseDeliveryLookupForm },
  menu: purchaseDeliveryMenu,
} as IRecordTypeDefinition;
